import { useEffect } from 'react';
import ScrollReveal from 'scrollreveal';

const useScrollReveal = (onlyOnce = true) => {
  useEffect(() => {
    const configTop = {
      delay: 75,
      duration: 1500,
      opacity: 0,
      distance: '50%',
      origin: 'top',
      reset: !onlyOnce,
    };

    const configRight = {
      delay: 125,
      duration: 1500,
      opacity: 0,
      distance: '-50%',
      origin: 'right',
      reset: !onlyOnce,
    };

    const configBottom = {
      delay: 175,
      duration: 1500,
      opacity: 0,
      distance: '50%',
      origin: 'bottom',
      reset: !onlyOnce,
    };

    ScrollReveal().reveal('.scroll-top', configTop);
    ScrollReveal().reveal('.scroll-right', configRight);
    ScrollReveal().reveal('.scroll-bottom', configBottom);
  }, [onlyOnce]);
};

export default useScrollReveal;